import { useState } from "react";
import { Plus, Trash } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

export const ClientAppointmentsCard = ({ clientId, appointments, onChanged }) => {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [label, setLabel] = useState("");
  const [busy, setBusy] = useState(false);

  const add = async () => {
    if (!date || !label.trim()) { toast.error("Date and description are required"); return; }
    setBusy(true);
    try {
      await api.post(`/clients/${clientId}/appointments`, { date, time, label: label.trim() });
      toast.success("Appointment added — it's on the calendar");
      setDate(""); setTime(""); setLabel("");
      onChanged?.();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  const remove = async (apid) => {
    try {
      await api.delete(`/clients/${clientId}/appointments/${apid}`);
      onChanged?.();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  const upcoming = (appointments || []).slice().sort((a, b) => (a.date + (a.time || "")).localeCompare(b.date + (b.time || "")));

  return (
    <div className="rounded-xl border border-stone-200 bg-white p-6 shadow-sm" data-testid="client-appointments-card">
      <p className="font-heading text-sm font-semibold text-stone-900">Appointments</p>
      <p className="mt-0.5 text-xs text-stone-500">Doctor visits, home visits, reviews — anything dated. Shows on the office calendar.</p>
      <div className="mt-3 grid gap-2 sm:grid-cols-[130px_100px_1fr_auto]">
        <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="border-stone-300 bg-white" data-testid="appt-date" />
        <Input type="time" value={time} onChange={(e) => setTime(e.target.value)} className="border-stone-300 bg-white" data-testid="appt-time" />
        <Input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="e.g. PCP follow-up, podiatrist…" className="border-stone-300 bg-white" data-testid="appt-label" />
        <Button onClick={add} disabled={busy} className="bg-primary text-primary-foreground hover:bg-stone-900" data-testid="appt-add">
          <Plus size={14} className="mr-1" /> {busy ? "Adding…" : "Add"}
        </Button>
      </div>
      {upcoming.length > 0 && (
        <div className="mt-3 space-y-1.5 border-t border-stone-100 pt-3" data-testid="appt-list">
          {upcoming.map((a) => (
            <div key={a.id} className="flex items-center justify-between gap-2 rounded-lg border border-stone-100 px-3 py-2" data-testid={`appt-${a.id}`}>
              <p className="text-sm text-stone-700">
                <span className="font-medium">{a.date}{a.time ? ` ${a.time}` : ""}</span> — {a.label}
              </p>
              <button onClick={() => remove(a.id)} className="text-stone-400 hover:text-[#C0392B]" data-testid={`appt-del-${a.id}`}><Trash size={14} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
